import { icons } from "../../assets/icons";

export const rolesColumnsForGroupCreate = [
  { Header: "Role", accessor: "name" },
  { Header: "Description", accessor: "description" },
];

export const rolesListColumns = (deleteRole, isRoleClickable = true, editRole ) => [
  { Header: "Role Name", accessor: "name" },
  { Header: "Created By", accessor: "createdBy" },
  {
    Header: "Created On",
    accessor: "added",
  },
  { Header: "Last Updated By", accessor: "lastUpdatedBy" },
  {
    Header: "Last Updated On",
    accessor: "updated",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: (props) => {
      if(isRoleClickable){
        return (
          <div className="flex items-center gap-x-10 cursor-pointer">
            <img src={icons.editIcon} onClick={() => editRole(props?.row?.original)}/>
            <img src={icons.trashIcon} onClick={() => deleteRole(props?.row?.original.id)}/>
            {/* <img src={icons.trashIcon} /> */}
          </div>
        );
      }
    },
  },
];
